import axios from "axios";
import Keycloak from "keycloak-js";
import { IAM_URL, AUTH_URL, IAM_URL_RICE } from "../url";
import { getRegistrationToken } from "./FireBaseService";
const keycloak = new Keycloak({
  url: `${AUTH_URL}`,
  realm: process.env.REACT_APP_REALM,
  clientId: process.env.REACT_APP_CLIENT_ID,
});
const initKeycloak = (onAuthenticatedCallback) => {
  keycloak
    .init({
      onLoad: "login-required",
      pkceMethod: "S256",
      checkLoginIframe: false,
    })
    .then(async (authenticated) => {
      if (authenticated) {
        const locale = keycloak?.tokenParsed?.locale
        if(['en','si','ta'].includes(locale)){
          sessionStorage.setItem('langFromKcToken', locale)
        }
        sessionStorage.setItem(
          process.env.REACT_APP_TOKEN_REFERENCE,
          keycloak.token || "no"
        );
        const user = await GetLabUserDetails();
        sessionStorage.setItem("labId", user?.data?.id);
        sessionStorage.setItem("user", JSON.stringify(user?.data));
        onAuthenticatedCallback();
        false && getRegistrationToken();
      } else {
        doLogin();
      }
    });
};

const clearAllLocalstorage = () => {
  localStorage.removeItem("current-page-path");
  localStorage.removeItem("isAdmin");
  sessionStorage.removeItem("id");
  sessionStorage.removeItem("user");
  localStorage.removeItem('preferredLang')
  sessionStorage.removeItem('langFromKcToken')
  sessionStorage.removeItem("labId");
};

const doLogin = keycloak.login;

const doLogout = () => {
  clearAllLocalstorage();
  keycloak.logout();
};

const getToken = () => keycloak.token;

const isLoggedIn = () => !!keycloak.token;

const updateToken = (successCallback) =>
  keycloak.updateToken(5).then(successCallback).catch(doLogin);

keycloak.onTokenExpired = () => {
  updateToken().then(() => {
    if (keycloak?.token) {
      sessionStorage.setItem(
        process.env.REACT_APP_TOKEN_REFERENCE ,
        keycloak.token
      );
    }
  });
};

const getUsername = () => keycloak.tokenParsed?.preferred_username;

const getUserEmail = () => keycloak.tokenParsed?.email;

const getEmployeeId = () => keycloak.tokenParsed?.employeeId;

const hasRole = (roles) => roles.some((role) => keycloak.hasRealmRole(role));

const GetLabUserDetails = async () => {
  try {
    return axios.get(`${IAM_URL_RICE}user/details`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  } catch (error) {}
};

const getUserDetail = () => {
  const user = sessionStorage.getItem("user");
  return JSON.parse(user);
};

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  getUserEmail,
  getEmployeeId,
  hasRole,
  getUserDetail,
};

export default KeycloakService;
